import { Controller } from "@hotwired/stimulus"

// While a publisher transcript is being fetched, ask how it is going and
// re-render the page once it has landed. Same shape as the download poll:
// it stops the moment there is nothing left to wait for.
export default class extends Controller {
  static values = { url: String, state: String }

  connect() {
    if (!["queued", "running"].includes(this.stateValue)) return
    this.tries = 0
    this.#schedule()
  }

  disconnect() { if (this.timer) clearTimeout(this.timer) }

  #schedule() {
    // Back off: a long transcript takes a few seconds, a stuck one should
    // not be asked about every two seconds forever.
    if (this.tries > 40) return
    this.timer = setTimeout(() => this.#poll(), this.tries < 10 ? 2000 : 5000)
  }

  async #poll() {
    this.tries++
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) throw new Error(response.status)
      const { state, cues } = await response.json()
      if (cues > 0 || state === "failed" || state === "none") {
        if (window.Turbo) window.Turbo.visit(window.location.href, { action: "replace" })
        else window.location.reload()
        return
      }
    } catch (_error) { /* keep waiting */ }
    this.#schedule()
  }
}
